/**
 * Consent logic for Enterprise Group join requests
 * Separates consent text and versioning from UI components
 */

export const ENTERPRISE_GROUP_JOIN_CONSENT_VERSION = 'enterprise-group-join-v1';

/**
 * Builds the consent text for joining an Enterprise group
 * @param groupName - The name of the Enterprise group being joined
 * @param enterpriseLabel - The name/label of the Enterprise organization
 * @returns Consent text string (under 1000 chars for backend validation)
 */
export function buildEnterpriseGroupJoinConsentText(groupName: string, enterpriseLabel: string): string {
  return `By requesting to join "${groupName}", you acknowledge and agree that ${enterpriseLabel} may access aggregated and de-identified reports derived from users associated with your consultant groups on this platform. Reports are provided only as statistical summaries and charts (e.g., averages, distributions, trends) and do not include individual-level reports, raw assessment responses, or personally identifiable information. You represent that you have the authority and all necessary permissions to enable this aggregated reporting.`;
}
